import { render } from "./SelectFloating.vue?vue&type=template&id=506fac68"
import script from "./SelectFloating.vue?vue&type=script&lang=js"
export * from "./SelectFloating.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__